import React from 'react';
import _ from 'lodash';
import { Chip } from '@mui/material';
import { taskBaseColor } from '../../utility/task';
import { TaskStatus } from '../../types/Task';

interface ITaskStatusPillProps {
  status: TaskStatus;
}

export default function TaskStatusPill({ status }: ITaskStatusPillProps) {
  const prettyStatus = _.startCase(status);

  return (
    <Chip
      label={prettyStatus}
      sx={{
        borderRadius: '6px',
        height: '28px',
        background: `${taskBaseColor(status)}30`,
        border: `1px solid ${taskBaseColor(status)}80`,
      }}
    />
  );
}
